import MultiFileUpload from './MultiFileUpload'

export default MultiFileUpload